import React from 'react';
import { Link } from 'react-router-dom';
import { Card } from '../ui/card';
import { Crown } from 'lucide-react';

const BureauTab = ({ bureauMembers, getAvatarUrl, getBureauRoleLabel }) => {
  // Sort bureau members by role importance
  const roleOrder = ['president', 'vice_president', 'secretary', 'treasurer', 'member'];
  const sortedMembers = [...bureauMembers].sort((a, b) => {
    return roleOrder.indexOf(a.bureau_role) - roleOrder.indexOf(b.bureau_role);
  });

  return (
    <Card className="bg-gradient-to-br from-purple-900/40 to-black border-2 border-purple-500/30 p-4 sm:p-8">
      <h2 className="text-xl sm:text-2xl font-bold text-purple-300 mb-6">
        Membres du Bureau
      </h2>
      
      {sortedMembers.length === 0 ? (
        <div className="text-center py-12 text-gray-400">
          Aucun membre du bureau défini
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
          {sortedMembers.map((member) => (
            <Link 
              key={member.user_id}
              to={`/member/${member.user_id}`}
              className="block"
            >
              <div className="p-4 sm:p-6 bg-black/30 rounded-lg border border-purple-500/20 hover:border-purple-400/40 transition-all text-center group">
                {member.avatar ? (
                  <img 
                    src={getAvatarUrl(member.avatar)} 
                    alt={member.name} 
                    className="h-20 w-20 sm:h-24 sm:w-24 rounded-full border-2 border-purple-500/50 object-cover mx-auto mb-4 group-hover:border-purple-400 transition-colors"
                  />
                ) : (
                  <div className="h-20 w-20 sm:h-24 sm:w-24 rounded-full bg-purple-600 flex items-center justify-center text-2xl sm:text-3xl font-bold text-white mx-auto mb-4 group-hover:bg-purple-500 transition-colors">
                    {member.name.charAt(0)}
                  </div>
                )}
                <h3 className="text-base sm:text-lg font-bold text-purple-200 group-hover:text-purple-100 transition-colors">
                  {member.name}
                </h3>
                <div className="flex items-center justify-center gap-2 mt-2">
                  <Crown className="h-4 w-4 text-yellow-400" />
                  <span className="text-yellow-400 font-semibold text-sm sm:text-base">
                    {getBureauRoleLabel(member.bureau_role)}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </Card>
  );
};

export default BureauTab;
